import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useRef } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { SqlEditor } from './SqlEditor';
import { FeedbackPanel } from './FeedbackPanel';
import { SchemaReference } from './SchemaReference';
import styles from '../../styles/LessonView.module.css';
export function TaskPanel({ description, hints, hintsRevealed, totalHints, attempts, xpReward, onCheck, onRevealHint, completionResult, }) {
    const [lastResult, setLastResult] = useState(null);
    const [checking, setChecking] = useState(false);
    const getValueRef = useRef(null);
    const handleExecute = async (sql) => {
        if (!sql || checking)
            return;
        setChecking(true);
        try {
            const result = await onCheck(sql);
            setLastResult(result);
        }
        finally {
            setChecking(false);
        }
    };
    const handleCheckClick = () => {
        const value = getValueRef.current?.() ?? '';
        if (value) {
            handleExecute(value);
        }
    };
    const allHintsRevealed = hintsRevealed >= totalHints;
    return (_jsxs("div", { className: styles.taskSection, children: [_jsx("div", { className: styles.sectionLabel, children: "\uD83D\uDCCB \u0417\u0430\u0434\u0430\u043D\u0438\u0435" }), _jsx("div", { className: styles.taskDescription, children: _jsx(ReactMarkdown, { remarkPlugins: [remarkGfm], components: {
                        table: ({ children }) => (_jsx("div", { className: styles.tableWrapper, children: _jsx("table", { children: children }) })),
                    }, children: description }) }), _jsx(SchemaReference, {}), _jsx("div", { className: styles.editorWrapper, children: _jsx(SqlEditor, { onExecute: handleExecute, getValueRef: getValueRef }) }), _jsxs("div", { className: styles.actions, children: [_jsx("button", { className: styles.runBtn, onClick: handleCheckClick, disabled: checking, children: checking ? '⏳ Проверяю...' : '▶ Проверить' }), _jsxs("button", { className: styles.hintBtn, onClick: onRevealHint, disabled: allHintsRevealed, children: ["\uD83D\uDCA1 \u041F\u043E\u0434\u0441\u043A\u0430\u0437\u043A\u0430 (", hintsRevealed, "/", totalHints, ")"] }), _jsx("span", { className: styles.shortcut, children: "Ctrl+Enter \u0434\u043B\u044F \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438" })] }), hints.length > 0 && (_jsx("div", { className: styles.hints, children: hints.map((hint, i) => (_jsxs("div", { className: styles.hint, children: ["\uD83D\uDCA1 ", hint] }, i))) })), lastResult && (_jsx(FeedbackPanel, { result: lastResult, attempts: attempts, hintsUsed: hintsRevealed, xpReward: xpReward, completionResult: completionResult }))] }));
}
